import Hls from 'hls.js';

import { HLS_START_LEVEL } from 'constants/hls';

const excludeNull = config =>
  Object.fromEntries(
    Object.entries(config).filter(([_, value]) => {
      return Boolean(value);
    })
  );

export const getHlsConfig = (
  clientConfigOverride?: { autoStartLoad: boolean },
  serverConfigOverride?: Record<string, unknown>
): Hls.HlsConfig => {
  // This is the default config we will be using
  // if there an outage in LD and we failed to
  // fetch the configuration from the server.
  const defaultConfig = {
    ...Hls.DefaultConfig,
    capLevelToPlayerSize: true,
    testBandwidth: false,
    startLevel: HLS_START_LEVEL,
    maxMaxBufferLength: 20, // in seconds
  };

  return {
    ...defaultConfig,
    ...clientConfigOverride,
    ...excludeNull(serverConfigOverride),
  };
};
